import {
  EventPostFields,
  FullPostFields,
  LinkPostFields,
  PollPostFields,
  PostType,
  ThreadPostFields,
} from '../CreateCardModal';

interface GetPostTypeValueDefaultArgs {
  fullPostFilledFields?: FullPostFields;
  linkPostFilledFields?: LinkPostFields;
  threadPostFilledFields?: ThreadPostFields;
  pollPostFilledFields?: PollPostFields;
  eventPostFilledFields?: EventPostFields;
}

export const getPostTypeValueDefault = ({
  fullPostFilledFields,
  linkPostFilledFields,
  threadPostFilledFields,
  pollPostFilledFields,
  eventPostFilledFields,
}: GetPostTypeValueDefaultArgs) => {
  switch (true) {
    case Boolean(fullPostFilledFields):
      return PostType.FULL;
    case Boolean(linkPostFilledFields):
      return PostType.LINK;
    case Boolean(threadPostFilledFields):
      return PostType.THREAD;
    case Boolean(pollPostFilledFields):
      return PostType.POLL;
    case Boolean(eventPostFilledFields):
      return PostType.EVENT;
    default:
      return PostType.SHORT;
  }
};
